// @ts-check
import { Role } from "../consts/roles.consts"
import { SHORTCUT_ITEMS } from "../consts/shortcuts.consts"
import { getActiveClientsOfTeamLeader } from "../services/client.service"

/**
 * @param {import("../contexts/auth/SessionContext").UserData} user
 */
export async function buildAllowedShortcuts(user) {
  if (!user) {
    return []
  }

  let shortcuts = [...SHORTCUT_ITEMS]

  if (user.projectRole === Role.TEAM_LEADER) {
    // Team leaders can only see shortcuts for clients they have access to or that are not client-specific
    const response = await getActiveClientsOfTeamLeader()

    if (response.success && response.result) {
      const clientCodes = new Set(
        response.result.map((client) => client.data.code)
      )

      shortcuts = filterShortcutsByClientAccess(shortcuts, clientCodes)
    }
  }

  shortcuts = filterShortcutsByRole(shortcuts, user.projectRole)

  return shortcuts
}

/**
 * @param {import("../types/shortcuts").ShortcutItem[]} shortcuts
 * @param {Set<string>} accessibleClientCodes
 */
function filterShortcutsByClientAccess(shortcuts, accessibleClientCodes) {
  return shortcuts.filter((shortcut) => {
    if (!shortcut.clientCode) {
      return true
    }

    return accessibleClientCodes.has(shortcut.clientCode)
  })
}

/**
 * @param {import("../types/shortcuts").ShortcutItem[]} shortcuts
 * @param {(typeof Role)[keyof typeof Role]} role
 */
function filterShortcutsByRole(shortcuts, role) {
  return shortcuts.filter(({ visibility }) => {
    if (!visibility?.roles) {
      return true
    }

    return visibility.roles.includes(role)
  })
}
